import React from "react";
import { Link } from "react-router-dom";
import "./FaqsHandbookSection.css";

const FaqsHandbookSection = () => {
  return (
    <section className="_fHSec_z1A_">
      <div className="_sCont_a2B_">
        <h2 className=" _hTitle_s5E_ workflow-title">Quick Answers & Guides</h2>
        <p className="_sDesc_c4D_">
          Browse our
          <Link to="/faq" className="_rLink_d5E_ _pLink_e6F_">
            FAQ,
          </Link>
          <Link to="/support-handbook" className="_rLink_d5E_ _gLink_f7G_">
            Support Handbook,
          </Link>
          or
          <Link to="/sop" className="_rLink_d5E_ _bLink_h8H_">
            SOP
          </Link>
          for detailed help, policies, and step-by-step guidance.
        </p>
      </div>
    </section>
  );
};

export default FaqsHandbookSection;
